import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import Warning from '@mui/icons-material/Warning';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

function PavoChip(props) {
    const { type, label, ...chipProps } = props;

    switch (type) {
        case 'cancelled':
            return (
                <Chip
                    {...chipProps}
                    color="error"
                    label={label ? label : 'Cancelled'}
                    icon={<CancelIcon />}
                />
            );
        case 'open':
            return (
                <Chip
                    {...chipProps}
                    color={'primary'}
                    label={label ? label : 'Open'}
                    icon={<RadioButtonUncheckedIcon />}
                />
            );
        case 'active':
            return (
                <Chip
                    {...chipProps}
                    color={'success'}
                    icon={<DoneIcon />}
                    label={label ? label : 'Active'}
                />
            );
        case 'inactive':
            return (
                <Chip
                    {...chipProps}
                    color={'error'}
                    icon={<ClearIcon />}
                    label={label ? label : 'Inactive'}
                />
            );
        case 'warning':
            return (
                <Chip
                    {...chipProps}
                    color={'warning'}
                    icon={<Warning />}
                    label={label ? label : 'Warning'}
                />
            );
        default:
            return <Chip {...props} />;
    }
}

PavoChip.propTypes = {
    type: PropTypes.string,
    label: PropTypes.string,
};

export default PavoChip;
